import React, { useState, useEffect } from 'react';
import contractService from '../../services/ContractService';

const LayerPdf = ({ contract, type, show, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [fileUrl, setFileUrl] = useState(null);

    const closeSlide = () => {
        setIsLoading(false);
        setFileUrl(null);
        onClose();
    };
    const downloadPdf = () => {
        if (!fileUrl) return;
        const a = document.createElement('a');
        a.href = fileUrl;
        var typeName = contract.contractType.startsWith("Vendita") ? "VENDITA": "NOLEGGIO";
        var typeProject = type === "CONTRATTO" ? "QTN_" : "PRJ_";
        var eventName = contract.eventName != '' ? contract.eventName+contract.eventYear : typeName;
        a.download = (contract.startDate.slice(0, 4) + contract.number.toString().padStart(3, "0")
            +typeProject+contract.clientName.replace(/\./g, '')+'_'+eventName+'.pdf').trim().replace(/\s+/g, '') ;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    const fetchPdf= async (id,type) => {
        if (id) {
            setIsLoading(true);
            contractService.getPdf(id,type)
            .then((res) => {
                const url = URL.createObjectURL(res.data);
                setFileUrl(url);
            }).catch((error) => {
                console.error("Error get file: ", error);
                if (error.status === 404) {
                    setFileUrl(404);
                }
            });
        }
    }
    useEffect(() => {
        fetchPdf(contract.id_contract,type);
    }, [contract,type]);

    return (
        <>
        <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">{type} {contract.number.toString().padStart(3, "0")}</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
                { fileUrl && fileUrl != 404  && (
                    <button onClick={downloadPdf} className="bx bx-download btn-download text-reset"></button>
                    )
                }
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                <div className="row">
                    {isLoading && !fileUrl ? (
                        <p>Caricamento in corso...</p>
                    ) : fileUrl === 404  ? (
                            <div className="mb-6 text-center alert alert-outline-danger">Documento non trovato, carica il documento.</div>
                    ) : (
                            <iframe
                              src={fileUrl}
                              width="100%"
                              height="1000px"
                              title="Documento Contratto"
                            />
                    )}
                </div>
            </div>
        </div>
    </>
  );
};

export default LayerPdf;
